import { render, staticRenderFns } from "./form-radio.vue?vue&type=template&id=8ac8c482"
import script from "./form-radio.vue?vue&type=script&lang=js"
export * from "./form-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports